<div
  class="gw-flex gw-items-center gw-justify-between gw-p-6 gw-border-b gw-border-border-normal"
>
  <h4
    class="gw-text-xl gw-font-semibold gw-text-text-primary"
    id="modal-basic-title"
  >
    {{ 'features.integrations.configureCredentials' | translate }}
  </h4>
</div>
<div class="gw-p-6">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="gw-space-y-4">
    <!-- Sandbox Mode -->
    <div class="gw-mb-4 gw-flex gw-items-center gw-gap-2">
      <input
        type="checkbox"
        class="gw-w-4 gw-h-4 gw-rounded gw-border-border-normal"
        formControlName="sandbox"
        id="sandbox"
      />
      <label
        for="sandbox"
        class="gw-text-sm gw-font-medium gw-text-text-primary"
      >
        {{ 'features.integrations.sandboxMode' | translate }}
      </label>
    </div>

    <!-- Client ID -->
    <div class="gw-mb-4">
      <label
        for="clientId"
        class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
      >
        {{ 'features.integrations.clientId' | translate }}
      </label>
      <input
        id="clientId"
        type="text"
        class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
        formControlName="clientId"
        [placeholder]="'features.integrations.clientIdPlaceholder' | translate"
        autocomplete="off"
      />
      <small
        *ngIf="form.get('clientId')?.invalid && form.get('clientId')?.touched"
        class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
      >
        {{ 'features.integrations.clientIdRequired' | translate }}
      </small>
    </div>

    <!-- Client Secret -->
    <div class="gw-mb-4">
      <label
        for="clientSecret"
        class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
      >
        {{ 'features.integrations.clientSecret' | translate }}
      </label>
      <div class="gw-relative">
        <input
          id="clientSecret"
          [type]="showSecret ? 'text' : 'password'"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          formControlName="clientSecret"
          [placeholder]="
            'features.integrations.clientSecretPlaceholder' | translate
          "
          autocomplete="off"
        />
        <button
          type="button"
          class="gw-absolute gw-right-2 gw-top-2 gw-p-1 gw-text-text-secondary hover:gw-text-text-primary"
          (click)="showSecret = !showSecret"
        >
          <gatewee-icon
            [icon]="showSecret ? '@tui.eye-off' : '@tui.eye'"
            size="16px"
          ></gatewee-icon>
        </button>
      </div>
      <small
        *ngIf="
          form.get('clientSecret')?.invalid && form.get('clientSecret')?.touched
        "
        class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
      >
        {{ 'features.integrations.clientSecretRequired' | translate }}
      </small>
    </div>

    <!-- mTLS Certificate (required) -->
    <div class="gw-mb-4">
      <label
        for="mtlsCertFile"
        class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
      >
        {{ 'features.integrations.mtlsCert' | translate }}
      </label>
      <input
        id="mtlsCertFile"
        type="file"
        class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
        (change)="onFileChange($event)"
        accept=".pem,.crt,.cer,.txt"
      />
      <small
        class="gw-text-text-secondary gw-text-sm gw-mt-1 gw-block"
        *ngIf="mtlsCertFileName"
      >
        {{ 'features.integrations.selected' | translate }}:
        {{ mtlsCertFileName }}
      </small>
      <small
        *ngIf="form.get('mtlsCert')?.invalid && form.get('mtlsCert')?.touched"
        class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
      >
        {{ 'features.integrations.mtlsCertRequired' | translate }}
      </small>
    </div>

    <div class="gw-flex gw-justify-end gw-gap-3 gw-mt-6">
      <gatewee-button
        [title]="'common.actions.cancel' | translate"
        variant="secondary"
        (click)="close()"
      ></gatewee-button>
      <gatewee-button
        [title]="
          submitting
            ? ('common.actions.saving' | translate)
            : ('common.actions.save' | translate)
        "
        variant="primary"
        type="submit"
        [disabled]="form.invalid || submitting"
      ></gatewee-button>
    </div>
  </form>
</div>
